import {
  ArrowToLeft,
  ArrowToRightIcon,
  GridLayoutIconRent,
  MapLineIconRent,
  NUSDIcon,
  PinLocationIconRent,
  ShortRentalIcon,
} from "../../AssetComponents/Images";
import { Popover } from "react-tiny-popover";
import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import propertyService from "../../Services/PropertyService";
import {
  selectAllProperties,
  selectFilteredProperties,
  selectVisibleProperties,
  selectIsLoading,
  selectIsPreloading,
  selectHasMoreProperties,
  selectIsCacheValid,
  selectError,
  loadMoreProperties,
  setFilteredProperties,
  setSearchResults,
  clearSearchResults,
  resetPagination,
} from "../../ReduxSlices/RentalPropertySlice";
import { mapStyles } from "../../Components/GoogleMap/Style";
import {
  MapShareIcon,
  MapPlusIcon,
  MapMinusIcon,
} from "../../AssetComponents/Images";
import Modal from "react-responsive-modal";
import { GoogleMap, OverlayView, Marker } from "@react-google-maps/api";
import mapPinIcon from "../../assets/images/Dashboard/Dashboard/mappin.svg";
import "react-range-slider-input/dist/style.css";
import { setPriceRange } from "../../ReduxSlices/SearchSlice";

import { api } from "../../Components/functions/Apiwithouttoken";
import { RentalItem } from "../../Components/RealEstateProperty/RentalItem";
import { RentalNavigation1 } from "./Rentalnavigation";
import { RentalSearch1 } from "./FakeSearch";
import { Filter1 } from "./FakeFilter";
import Listings1 from "./FakeListings";
import { PropertySkeletonGrid } from "../../Components/RealEstateProperty/PropertySkeleton";
import { PurpleButton } from "../../Components/Buttons/PurpleButton";
import { BlackButton } from "../../Components/Buttons/BlackButton";
import HomeIcons from "../../Components/Rent/HomeIcons";
import Chatbot from "./ChatBot";
import { Header } from "./FakeHeader";
import { OnboardingProvider, useOnboarding } from "./OnBoarding1";
import OnboardingModal from "./OnBoardingModal";
import { Toaster } from "./Toast";
import Chatboticon from "../../Components/Chatbot/chatboticon";
import Logo1 from "../../assets/images/logoForQRcode.svg";

export const InstructionRent = () => {
  return (
    <OnboardingProvider>
      <InstructionRentContent />
    </OnboardingProvider>
  );
};

const InstructionRentContent = () => {
  const [showMapMenu, setShowMapMenu] = useState(false);
  const [mobileView, setMobileView] = useState('list'); // Add mobile view state like Rent.js
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const account = useSelector((state) => state.auth.account);
  const { startOnboarding, isOnboarding, currentStep, nextStep, prevStep, skipOnboarding, completeOnboarding, setCurrentStep, showConfirmModal, pendingNavigation, requestTourSwitch, confirmTourSwitch, cancelTourSwitch } = useOnboarding();
  const [searchParams] = useSearchParams();

  // Remove the completion redirect useEffect since we're extending to step 9
  // Also ensure we don't interfere with the host dashboard onboarding

  // Add this useEffect as a backup to start onboarding
  useEffect(() => {
    // Remove localStorage check, use only session/in-memory
    // const hasSeenOnboarding = localStorage.getItem('hasSeenOnboarding');
    
    console.log('InstructionRentContent - checking onboarding:', { 
      // hasSeenOnboarding, 
      pathname: location.pathname,
      isOnboarding,
      currentStep 
    });
    
    // Only start onboarding if it's not already running and we're on the steps page
    if (location.pathname.includes('/onboarding/steps') && !isOnboarding) {
      startOnboarding();
    }
  }, [location.pathname, startOnboarding, isOnboarding]);

  // Remove localStorage from skip handler
  const handleSkipOnboarding = () => {
    // localStorage.setItem('hasSeenOnboarding', 'true');
    skipOnboarding();
            navigate('/rent/all');
  };

  const reservation_period = useSelector((state) => state.reservation.period);
  const who = useSelector((state) => state.reservation.who);
  const guests = useSelector((state) => state.reservation.guests);
  const [metaDetails, setMetaDetails] = useState({
    amenities: {},
  });
  
  // Use Redux state instead of local state
  const properties = useSelector(selectAllProperties);
  const filteredProperties = useSelector(selectFilteredProperties);
  const visibleProperties = useSelector(selectVisibleProperties);
  const loading = useSelector(selectIsLoading);
  const isPreloading = useSelector(selectIsPreloading);
  const hasMoreProperties = useSelector(selectHasMoreProperties);
  const isCacheValid = useSelector(selectIsCacheValid);
  const error = useSelector(selectError);
  
  const [sortType, setSortType] = useState("default");
  const ITEMS_PER_BATCH = 8;



  const handleLoadMoreProperties = useCallback(() => {
    if (hasMoreProperties && !loading) {
      dispatch(loadMoreProperties());
    }
  }, [hasMoreProperties, loading, dispatch]);

  // const defaultPeriod = [
  //   {
  //     startDate: reservation_period.start
  //       ? new Date(reservation_period.start * 1000)
  //       : new Date(),
  //     endDate: reservation_period.end
  //       ? new Date(reservation_period.end * 1000)
  //       : new Date(),
  //     key: "selection",
  //     color: "#5b1deeaa",
  //   },
  // ];
  // const [period, setPeriod] = useState(defaultPeriod);
  const [openFilter, setOpenFilter] = useState(false);
  // Remove the duplicate dispatch line if it exists later
  const [zoom, setZoom] = useState(10);
  const [currentCategory, setCurrentCategory] = useState("Bathroom");
  const [activeToken, setActiveToken] = useState();
  const [fullScreen, setFullScreen] = useState(false);
  const [hideMap, setHideMap] = useState(false);
  const geocoder = new window.google.maps.Geocoder();
  const range = useSelector((state) => state.search.priceRange);
  const [pinLocation, setPinLocation] = useState({
    lat: 25,
    lng: 55,
  });
const [isSearchResult, setIsSearchResult] = useState(false);
const [showWaitlistModal, setShowWaitlistModal] = useState(false);
const [waitlistData, setWaitlistData] = useState({ name: '', email: '' });
const [waitlistLoading, setWaitlistLoading] = useState(false);
const amenities = useSelector((state) => state.search.amenities);
const propertyType = useSelector((state) => state.search.propertyType);
const instantBook = useSelector((state) => state.search.instantBook);
const allowPets = useSelector((state) => state.search.allowPets);



  const handleSelectMapPin = async (pinLocation) => {
    // setAddressInput(res.results[0].formatted_address);
  };

  useEffect(() => {
    handleSelectMapPin(pinLocation);
  }, [pinLocation]);

 useEffect(() => {
  if (!range?.max)
    dispatch(
      setPriceRange({
        min: range?.min || 1,
        max: 10000, // Changed from 1000 to 10000
      })
    );
  if (!range?.min)
    dispatch(
      setPriceRange({
        min: 1,
        max: range?.max || 10000, // Changed from 1000 to 10000
      })
    );
}, [range]);


  const loadProperties = async () => {
    try {
      console.log('InstructionRental - Loading properties...');
      await propertyService.loadProperties(dispatch, { useCache: true });
      console.log('InstructionRental - Properties loaded successfully');
    } catch (error) {
      console.error('InstructionRental - Failed to load properties:', error);
    }
  };
  


  useEffect(() => {
    // Only load properties if not already cached or if cache is invalid
    if (!isCacheValid || properties.length === 0) {
      loadProperties();
    } else {
      console.log('InstructionRental - Using cached properties');
    }
  }, [isCacheValid, properties.length]);

  // Re-filter properties when account changes (wallet connects/disconnects)
  useEffect(() => {
    if (properties.length > 0) {
      console.log('InstructionRental - Account changed, re-filtering properties:', {
        account: account,
        totalProperties: properties.length
      });
      
      // Re-filter properties based on current account state
      const filteredArray = properties.filter(property => {
        // Check if property has the short object and isListed field
        if (!property?.short) return false;
        
        // Only show properties with isListed === true
        return property.short.islisted === true;
      });
      
      console.log(`InstructionRental - Re-filtered: Total: ${properties.length}, Listed: ${filteredArray.length}`);
      
      dispatch(setFilteredProperties(filteredArray));
    }
  }, [account, properties, dispatch]);

  // Debug effect to monitor filtering
  useEffect(() => {
    console.log('InstructionRental - Filtering Debug:', {
      totalProperties: properties.length,
      filteredProperties: filteredProperties.length,
      visibleProperties: visibleProperties.length,
      account: account,
      isConnected: !!account
    });
  }, [properties, filteredProperties, visibleProperties, account]);

  // Intersection Observer for infinite scroll
  const observerTarget = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (
          entries[0].isIntersecting &&
          !loading &&
          hasMoreProperties
        ) {
          handleLoadMoreProperties();
        }
      },
      { threshold: 0.1 }
    );

    if (observerTarget.current) {
      observer.observe(observerTarget.current);
    }

    return () => observer.disconnect();
  }, [loading, hasMoreProperties, handleLoadMoreProperties]);
const handleSearch = async (searchResults) => {
  // Handle special country-not-available response
  if (searchResults && typeof searchResults === 'object' && searchResults.countryNotAvailable === true) {
    dispatch(setSearchResults([]));
    setIsSearchResult(true);
    return;
  }
  
  if (searchResults && searchResults.length > 0) {
    dispatch(setSearchResults(searchResults));
    setIsSearchResult(true);
    
    // If search includes location, update pin location
    if (searchResults[0]?.metaData?.location) {
      setPinLocation({
        lat: searchResults[0].metaData.location.lat,
        lng: searchResults[0].metaData.location.lng
      });
    }
  } else {
    // No results found - don't show any properties
    dispatch(setSearchResults([]));
    setIsSearchResult(true); // This was a search with no results
  }
};

const handleSort = (sortedData) => {
  if (Array.isArray(sortedData) && sortedData.length > 0) {
    // Log detailed property information including ratings
    console.log('Frontend Render - Properties with ratings:', 
      sortedData?.slice(0, 5).map((item, index) => ({
        index,
        token_id: item.token_id,
        price_per_day: item.short?.price_per_day,
        averageRating: item.averageRating // Log the actual averageRating from backend
      }))
    );
    
    // Update filtered properties with sorted data from backend
    dispatch(setFilteredProperties(sortedData));
  } else {
    console.warn('Empty or invalid response received from sort:', sortedData);
    // Handle empty response - use already filtered properties, not all properties
    if (filteredProperties.length > 0) {
      dispatch(resetPagination());
      alert('No properties found with the selected sort criteria');
    } else {
      dispatch(setFilteredProperties([]));
    }
  }
};

const handleFilterChange = (filteredResults) => {
  if (filteredResults && filteredResults.length > 0) {
    dispatch(setFilteredProperties(filteredResults));
  } else {
    dispatch(setFilteredProperties([]));
  }
};

// Add waitlist handler functions
const handleJoinWaitlist = () => {
  setShowWaitlistModal(true);
};

const handleWaitlistSubmit = async () => {
  if (!waitlistData.name || !waitlistData.email) {
    alert('Please fill in both name and email');
    return;
  }

  setWaitlistLoading(true);
  
  try {
    const response = await api("waitlist/add", {
      Name: waitlistData.name,
      Email: waitlistData.email
    });
    
    if (response === true) {
      alert('Successfully added to waitlist! We\'ll notify you when properties are available in your area.');
      setShowWaitlistModal(false);
      setWaitlistData({ name: '', email: '' });
    } else {
      alert('Email already exists in our waitlist or there was an error. Please try again.');
    }
  } catch (error) {
    console.error('Waitlist error:', error);
    alert('Failed to add to waitlist. Please try again.');
  } finally {
    setWaitlistLoading(false);
  }
};

const handleResetFilters = () => {
  // Reset to show all properties
  dispatch(clearSearchResults());
  setIsSearchResult(false);
};


const NoResultsPrompt = ({ onJoinWaitlist, onResetFilters, isSearchResult = false }) => (
  <div className="flex flex-col items-center justify-center text-center">
    {isSearchResult ? (
      <div className="space-y-6 max-w-[500px]">
        <div className="text-2xl font-semibold text-gray-800">
          Location not available yet
        </div>
        <div className="text-lg text-gray-600">
          We don't have properties in this location yet, but we're expanding! 
          Join our waitlist to be notified when we add properties to your area
        </div>
        <div className="flex gap-4 justify-center">
          <PurpleButton 
            onClick={onJoinWaitlist}
             text={
                        

                            <span>Join Waitlist</span>
                    
                        }
          >
           
          </PurpleButton>
          <button 
            onClick={onResetFilters}
            className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 font-semibold"
          >
            Browse All Properties
          </button>
        </div>
      </div>
    ) : (
      <div className="space-y-4 flex flex-col items-center justify-center">
        <p className="text-lg text-gray-500 text-center">No properties match your filters</p>
        <button 
          onClick={onResetFilters} 
          className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
        >
          Reset Filters
        </button>
      </div>
    )}
  </div>
);



const handleReturnToDefault = () => {
  // Reset to show all properties
  dispatch(clearSearchResults());
};

const WaitlistModal = () => (
  <Modal
    open={showWaitlistModal}
    center
    onClose={() => setShowWaitlistModal(false)}
    classNames={{
      modal: "rounded-[8px] border-[1px] border-[#E3E3E3] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] bg-white",
    }}
    styles={{
      modal: {
        backgroundColor: '#ffffff',
        background: '#ffffff',
        opacity: 1,
      }
    }}
  >
    <div className="w-[400px] p-6">
      <h2 className="text-2xl font-semibold mb-4">Join Our Waitlist</h2>
      <p className="text-gray-600 mb-6">
        Be the first to know when we add properties to your desired location!
      </p>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Name
          </label>
          <input
            type="text"
            value={waitlistData.name}
            onChange={(e) => setWaitlistData({ ...waitlistData, name: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            placeholder="Enter your name"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email
          </label>
          <input
            type="email"
            value={waitlistData.email}
            onChange={(e) => setWaitlistData({ ...waitlistData, email: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            placeholder="Enter your email"
          />
        </div>
      </div>
      
      <div className="flex gap-3 mt-6">
        <button
          onClick={() => setShowWaitlistModal(false)}
          className="flex-1 px-4 py-2 text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300"
          disabled={waitlistLoading}
        >
          Cancel
        </button>
        <button
          onClick={handleWaitlistSubmit}
          className="flex-1 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50"
          disabled={waitlistLoading}
        >
          {waitlistLoading ? 'Adding...' : 'Join Waitlist'}
        </button>
      </div>
    </div>
  </Modal>
);

  useEffect(() => {
    // Add step param sync for onboarding
    const stepParam = searchParams.get('step');
    if (isOnboarding && stepParam) {
      const stepNum = Number(stepParam);
      if (!isNaN(stepNum) && stepNum !== currentStep) {
        setCurrentStep(stepNum);
      }
    }
  }, [searchParams, isOnboarding, currentStep, setCurrentStep]);

  const handleSwitchToHostTour = () => {
    requestTourSwitch('/onboarding/host?step=10', 'Would you like to tour as a Host?');
  };

  // Example: When finishing rental onboarding, prompt before switching to traveler
  const handleSwitchToTravelerTour = () => {
    requestTourSwitch('/onboarding/traveller?step=13', 'Would you like to tour as a Traveler?');
  };

  return (
    <div className={isOnboarding && (currentStep === 1 || currentStep === 2 || currentStep === 3 || currentStep === 4 || currentStep === 5 || currentStep === 6 || currentStep === 8) ? 'onboarding-blur' : ''}>
      {/* Confirmation Modal for switching onboarding flows */}
      {showConfirmModal && (
        <Modal
          open={true}
          center
          onClose={cancelTourSwitch}
          showCloseIcon={false}
          classNames={{
            modal: "w-[95vw] max-w-md rounded-xl border-none shadow-2xl bg-white",
          }}
          styles={{
            modal: { 
              zIndex: 10000,
              backgroundColor: '#ffffff',
              background: '#ffffff',
              opacity: 1,
            }
          }}
        >
          <div className="p-4 sm:p-6 text-center bg-white">
            <h2 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">{pendingNavigation?.message}</h2>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-4 sm:mt-6">
              <BlackButton text="Skip" onClick={() => {"/rent/onboarding/Completion"}} />
              <PurpleButton text="Yes, Continue" onClick={() => confirmTourSwitch(navigate)} />
            </div>
          </div>
        </Modal>
      )}
     
      <Header/>
      <div className="flex flex-col w-full h-full">
        <div className="w-full h-full flex flex-col">
          {/* Desktop Header */}
          <div className="hidden lg:flex w-full items-center justify-between px-[16px] my-[20px]">
            <div className="relative">
              <div className={isOnboarding && currentStep === 5 ? 'onboarding-highlight' : ''}>
                <RentalNavigation1
                  className="flex flex-col lg:flex-row items-center justify-between w-full px-4 py-2 lg:px-8 lg:py-4 bg-white shadow-md rounded-lg"
                />
              </div>
              
              {/* Navigation Onboarding Modal - positioned below RentalNavigation1 */}
              {isOnboarding && currentStep === 5 && (
                <div className="absolute top-full mt-4 left-0 w-[95vw] max-w-96 bg-white rounded-lg shadow-lg p-3 sm:p-4 border-4 border-purple-500 z-[1051] onboarding-highlight" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                  <div className="text-base sm:text-lg font-semibold mb-2">Navigate Your Listings</div>
                  <div className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">Switch between different types of rental listings to find exactly what you need</div>
                  
                  {/* Add navigation icon visual indicator */}
                  <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4 p-2 sm:p-3 bg-purple-50 rounded-lg">
                    <div className="w-6 h-6 sm:w-8 sm:h-8 bg-purple-600 rounded-full flex items-center justify-center text-white">
                      <svg className="w-3 h-3 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h7a1 1 0 100-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div className="text-xs sm:text-sm text-gray-700">
                      <div className="font-medium">Navigation Menu</div>
                      <div className="text-xs text-gray-500">Explore different listing types!</div>
                    </div>
                  </div>

                  {/* Long-term listings coming soon notice */}
                  <div className="bg-green-50 border border-green-200 rounded-lg p-2 sm:p-3 mb-3 sm:mb-4">
                    <div className="flex items-center gap-2">
                      <svg className="w-4 h-4 sm:w-5 sm:h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      <div className="text-xs sm:text-sm text-green-800">
                        <div className="font-medium">Long-Term Listings Coming Soon!</div>
                        <div className="text-xs">We're adding monthly and yearly rental options ASAP</div>
                      </div>
                    </div>
                  </div>

                  {/* Arrow pointing upward to navigation */}
                  <div className="absolute -top-3 left-8 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-purple-500 hidden sm:block"></div>
                  
                  <div className="flex flex-col sm:flex-row gap-2">
                    <BlackButton text="Back" onClick={() => prevStep()} />
                    <PurpleButton text="Next" onClick={() => nextStep()} />
                    <button 
                      onClick={handleSkipOnboarding}
                      className="px-3 sm:px-4 py-2 text-gray-500 hover:text-gray-700 text-sm"
                    >
                      Skip Guide
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div className="relative">
              <div className={isOnboarding && currentStep === 4 ? 'onboarding-highlight' : ''}>
                <RentalSearch1 onSearch={handleSearch} />
              </div>
              
              {/* Search Onboarding Modal - positioned below RentalSearch1 */}
              {isOnboarding && currentStep === 4 && (
                <div className="absolute top-full mt-4 left-1/2 transform -translate-x-1/2 w-[95vw] max-w-96 bg-white rounded-lg shadow-lg p-3 sm:p-4 border-4 border-purple-500 z-[1051] onboarding-highlight" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                  <div className="text-base sm:text-lg font-semibold mb-2">Search for Your Perfect Stay</div>
                  <div className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">Enter your destination, check-in/out dates, and number of guests for precise listings</div>
                  
                  {/* Add search icon visual indicator */}
                  <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4 p-2 sm:p-3 bg-purple-50 rounded-lg">
                    <div className="w-6 h-6 sm:w-8 sm:h-8 bg-purple-600 rounded-full flex items-center justify-center text-white">
                      <svg className="w-3 h-3 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <div className="text-xs sm:text-sm text-gray-700">
                      <div className="font-medium">Smart Search</div>
                      <div className="text-xs text-gray-500">Find exactly what you're looking for!</div>
                    </div>
                  </div>

                  {/* Dubai availability notice */}
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-2 sm:p-3 mb-3 sm:mb-4">
                    <div className="flex items-center gap-2">
                      <svg className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                      </svg>
                      <div className="text-xs sm:text-sm text-blue-800">
                        <div className="font-medium">Currently Available in Dubai Only</div>
                        <div className="text-xs">We're expanding to more locations soon!</div>
                      </div>
                    </div>
                  </div>

                  {/* Arrow pointing upward to search bar - hidden on mobile */}
                  <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-purple-500 hidden sm:block"></div>
                  
                  <div className="flex flex-col sm:flex-row gap-2">
                    <BlackButton text="Back" onClick={() => prevStep()} />
                    <PurpleButton text="Next" onClick={() => nextStep()} />
                    <button 
                      onClick={handleSkipOnboarding}
                      className="px-3 sm:px-4 py-2 text-gray-500 hover:text-gray-700 text-sm"
                    >
                      Skip Guide
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div className="flex items-center gap-[10px]">
              <div className="relative">
                <div className={isOnboarding && currentStep === 3 ? 'onboarding-highlight' : ''}>
                  <Filter1
                    properties={properties} 
                    onFilterChange={handleFilterChange}
                    currentSortType={sortType}
                  />
                </div>
                
                {/* Filter Onboarding Modal - positioned below Filter1 */}
                {isOnboarding && currentStep === 3 && (
                  <div className="absolute top-full mt-4 -left-4 w-[95vw] max-w-80 bg-white rounded-lg shadow-lg p-3 sm:p-4 border-4 border-purple-500 z-[1051] onboarding-highlight" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                    <div className="text-base sm:text-lg font-semibold mb-2">Narrow Your Search</div>
                    <div className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">Use filters to search by price, rating, type, and more</div>
                    
                    {/* Add filter icon visual indicator */}
                    <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4 p-2 sm:p-3 bg-purple-50 rounded-lg">
                      <div className="w-6 h-6 sm:w-8 sm:h-8 bg-purple-600 rounded-full flex items-center justify-center text-white">
                        <svg className="w-3 h-3 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div className="text-xs sm:text-sm text-gray-700">
                        <div className="font-medium">Filter Search</div>
                        <div className="text-xs text-gray-500">Click to filter by price, rating & more!</div>
                      </div>
                    </div>

                    {/* Arrow pointing upward to filter button - hidden on mobile */}
                    <div className="absolute -top-3 left-8 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-purple-500 hidden sm:block"></div>
                    
                    <div className="flex flex-col sm:flex-row gap-2">
                      <BlackButton text="Back" onClick={() => prevStep()} />
                      <PurpleButton text="Next" onClick={() => nextStep()} />
                      <button 
                        onClick={handleSkipOnboarding}
                        className="px-3 sm:px-4 py-2 text-gray-500 hover:text-gray-700 text-sm"
                      >
                        Skip Guide
                      </button>
                    </div>
                  </div>
                )}
              </div>
              
              <div className="relative">
                <div className={isOnboarding && currentStep === 2 ? 'onboarding-highlight' : ''}>
                  <Listings1 
                    onSort={handleSort} 
                    setSortType={setSortType}
                    filteredProperties={filteredProperties}
                  />
                </div>
                
                {/* Sort Listings Onboarding Modal - positioned below Listings1 */}
                {isOnboarding && currentStep === 2 && (
                  <div className="absolute top-full mt-4 -right-4 w-[95vw] max-w-80 bg-white rounded-lg shadow-lg p-3 sm:p-4 border-4 border-purple-500 z-[1051] onboarding-highlight" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                    <div className="text-base sm:text-lg font-semibold mb-2">Sort Your Listings</div>
                    <div className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">You can order listings according to price ranges, ratings, and more to find exactly what you're looking for!</div>
                    
                    {/* Add sorting icon visual indicator */}
                    <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4 p-2 sm:p-3 bg-purple-50 rounded-lg">
                      <div className="w-6 h-6 sm:w-8 sm:h-8 bg-purple-600 rounded-full flex items-center justify-center text-white">
                        <svg className="w-3 h-3 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div className="text-xs sm:text-sm text-gray-700">
                        <div className="font-medium">Sort Listings</div>
                        <div className="text-xs text-gray-500">Click to sort by price or rating!</div>
                      </div>
                    </div>

                    {/* Arrow pointing upward to sort button - hidden on mobile */}
                    <div className="absolute -top-3 right-8 w-0 h-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-purple-500 hidden sm:block"></div>
                    
                    <div className="flex flex-col sm:flex-row gap-2">
                      <BlackButton text="Back" onClick={() => prevStep()} />
                      <PurpleButton text="Next" onClick={() => nextStep()} />
                      <button 
                        onClick={handleSkipOnboarding}
                        className="px-3 sm:px-4 py-2 text-gray-500 hover:text-gray-700 text-sm"
                      >
                        Skip Guide
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Mobile Header - Copy from Rent.js */}
          <div className="lg:hidden flex flex-col w-full px-4 py-4 space-y-4">
            {/* Navigation */}
            <RentalNavigation1 className={isOnboarding && currentStep === 5 ? 'onboarding-highlight' : ''} />
            
            {/* Search Bar - Add highlight for step 4 */}
            <div className={isOnboarding && currentStep === 4 ? 'onboarding-highlight' : ''}>
              <RentalSearch1 onSearch={handleSearch} />
            </div>
            
            {/* Filter and Listings Controls */}
            <div className="flex items-center justify-between w-full gap-2">
              <div className={isOnboarding && currentStep === 3 ? 'onboarding-highlight' : ''}>
                <Filter1
                  properties={properties} 
                  onFilterChange={handleFilterChange}
                  currentSortType={sortType}
                />
              </div>
              <div className={isOnboarding && currentStep === 2 ? 'onboarding-highlight' : ''}>
                <Listings1 
                  onSort={handleSort} 
                  setSortType={setSortType}
                  filteredProperties={filteredProperties}
                />
              </div>
            </div>
            
            {/* Map/List Toggle - Copy exactly from Rent.js */}
            <div className="flex items-center justify-center bg-gray-100 rounded-lg p-1">
              <button
                onClick={() => setMobileView('list')}
                className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                  mobileView === 'list'
                    ? 'bg-white text-gray-900 shadow-sm'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                List
              </button>
              <button
                onClick={() => setMobileView('map')}
                className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
                  mobileView === 'map'
                    ? 'bg-white text-gray-900 shadow-sm'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                Map
              </button>
            </div>

            {/* Mobile Onboarding Modals - Positioned below toggle */}
            {isOnboarding && currentStep === 5 && (
              <div className="w-full max-w-full bg-white rounded-lg shadow-lg p-3 border-4 border-purple-500 z-[1051] onboarding-highlight overflow-hidden" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                <div className="text-base font-semibold mb-2">Navigate Your Listings</div>
                <div className="text-sm text-gray-600 mb-3">Switch between different types of rental listings to find exactly what you need.</div>
                
                <div className="flex items-center gap-2 mb-3 p-2 bg-purple-50 rounded-lg">
                  <div className="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center text-white flex-shrink-0">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M3 3a1 1 0 000 2h11a1 1 0 100-2H3zM3 7a1 1 0 000 2h7a1 1 0 100-2H3zM3 11a1 1 0 100 2h4a1 1 0 100-2H3z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="text-xs text-gray-700 min-w-0">
                    <div className="font-medium">Navigation Menu</div>
                    <div className="text-xs text-gray-500">Explore different listing types!</div>
                  </div>
                </div>

                <div className="bg-green-50 border border-green-200 rounded-lg p-2 mb-3">
                  <div className="flex items-start gap-2">
                    <svg className="w-4 h-4 text-green-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <div className="text-xs text-green-800 min-w-0">
                      <div className="font-medium">Long-Term Listings Coming Soon!</div>
                      <div className="text-xs break-words">We're adding monthly and yearly rental options ASAP.</div>
                    </div>
                  </div>
                </div>
                
                <div className="onboarding-modal-buttons">
                  <BlackButton text="Back" onClick={() => prevStep()} />
                  <PurpleButton text="Next" onClick={() => nextStep()} />
                  <button 
                    onClick={handleSkipOnboarding}
                    className="px-3 py-2 text-gray-500 hover:text-gray-700 text-sm"
                  >
                    Skip Guide
                  </button>
                </div>
              </div>
            )}

            {isOnboarding && currentStep === 4 && (
              <div className="w-full max-w-full bg-white rounded-lg shadow-lg p-3 border-4 border-purple-500 z-[1051] onboarding-highlight overflow-hidden" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                <div className="text-base font-semibold mb-2">Search for Your Perfect Stay</div>
                <div className="text-sm text-gray-600 mb-3">Enter your destination, check-in/out dates, and number of guests for precise listings.</div>
                
                <div className="flex items-center gap-2 mb-3 p-2 bg-purple-50 rounded-lg">
                  <div className="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center text-white flex-shrink-0">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="text-xs text-gray-700 min-w-0">
                    <div className="font-medium">Smart Search</div>
                    <div className="text-xs text-gray-500">Find exactly what you're looking for!</div>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-2 mb-3">
                  <div className="flex items-start gap-2">
                    <svg className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    <div className="text-xs text-blue-800 min-w-0">
                      <div className="font-medium">Currently Available in Dubai Only</div>
                      <div className="text-xs break-words">We're expanding to more locations soon!</div>
                    </div>
                  </div>
                </div>
                
                <div className="onboarding-modal-buttons">
                  <BlackButton text="Back" onClick={() => prevStep()} />
                  <PurpleButton text="Next" onClick={() => nextStep()} />
                  <button 
                    onClick={handleSkipOnboarding}
                    className="px-3 py-2 text-gray-500 hover:text-gray-700 text-sm"
                  >
                    Skip Guide
                  </button>
                </div>
              </div>
            )}

            {isOnboarding && currentStep === 3 && (
              <div className="w-full max-w-full bg-white rounded-lg shadow-lg p-3 border-4 border-purple-500 z-[1051] onboarding-highlight overflow-hidden" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                <div className="text-base font-semibold mb-2">Narrow Your Search</div>
                <div className="text-sm text-gray-600 mb-3">Use filters to search by price, rating, type, and more.</div>
                
                <div className="flex items-center gap-2 mb-3 p-2 bg-purple-50 rounded-lg">
                  <div className="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center text-white flex-shrink-0">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="text-xs text-gray-700 min-w-0">
                    <div className="font-medium">Filter Search</div>
                    <div className="text-xs text-gray-500">Click to filter by price, rating & more!</div>
                  </div>
                </div>
                
                <div className="onboarding-modal-buttons">
                  <BlackButton text="Back" onClick={() => prevStep()} />
                  <PurpleButton text="Next" onClick={() => nextStep()} />
                  <button 
                    onClick={handleSkipOnboarding}
                    className="px-3 py-2 text-gray-500 hover:text-gray-700 text-sm"
                  >
                    Skip Guide
                  </button>
                </div>
              </div>
            )}

            {isOnboarding && currentStep === 2 && (
              <div className="w-full max-w-full bg-white rounded-lg shadow-lg p-3 border-4 border-purple-500 z-[1051] onboarding-highlight overflow-hidden" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                <div className="text-base font-semibold mb-2">Sort Your Listings</div>
                <div className="text-sm text-gray-600 mb-3">You can order listings according to price ranges, ratings, and more to find exactly what you're looking for!</div>
                
                <div className="flex items-center gap-2 mb-3 p-2 bg-purple-50 rounded-lg">
                  <div className="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center text-white flex-shrink-0">
                    <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="text-xs text-gray-700 min-w-0">
                    <div className="font-medium">Sort Listings</div>
                    <div className="text-xs text-gray-500">Click to sort by price or rating!</div>
                  </div>
                </div>
                
                <div className="onboarding-modal-buttons">
                  <BlackButton text="Back" onClick={() => prevStep()} />
                  <PurpleButton text="Next" onClick={() => nextStep()} />
                  <button 
                    onClick={handleSkipOnboarding}
                    className="px-3 py-2 text-gray-500 hover:text-gray-700 text-sm"
                  >
                    Skip Guide
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Main Content */}
          {(location.pathname.includes("short") || location.pathname.includes("onboarding")) && (
            <>
              {/* Mobile Content - Copy structure from Rent.js */}
              <div className="lg:hidden w-full h-full">
                {mobileView === 'list' ? (
    <div className="w-full h-full overflow-auto px-4 pb-20 flex justify-center">
      <div className="w-full max-w-sm space-y-4 py-4">
        {(loading || isPreloading) ? (
          <div className="flex items-center justify-center min-h-[300px]">
            {isOnboarding && currentStep === 6 && (
              <div className="bg-white rounded-lg shadow-lg p-4 border-4 border-purple-500 z-[1051] onboarding-highlight w-full max-w-80" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                <div className="text-base sm:text-lg font-semibold mb-2">
                  {isPreloading ? 'Pre-loading Properties' : 'Loading Properties'}
                </div>
                <div className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                  {isPreloading 
                    ? 'Getting properties ready for your exploration...' 
                    : 'Please wait while we load available listings for you to explore.'
                  }
                </div>
                <div className="flex justify-center">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-purple-500" />
                </div>
              </div>
            )}
                           {!(isOnboarding && currentStep === 6) && (
              <PropertySkeletonGrid count={9} />
            )}
          </div>
                      ) : (
                        <>
                          {visibleProperties.length > 0 ? (
                            visibleProperties.map((nft, index) => (
                              <div key={index} className="w-full flex justify-center relative">
                                <RentalItem
                                  token_id={nft?.token_id}
                                  tokenData={nft}
                                  isFirstListing={index === 0}
                                  isOnboarding={isOnboarding}
                                  currentStep={currentStep}
                                />
                              </div>
                            ))
                          ) : (
                            <div className="flex items-center justify-center min-h-[300px]">
                              {isOnboarding && currentStep === 6 ? (
                                <div className="bg-white rounded-lg shadow-lg p-4 border-4 border-purple-500 z-[1051]  w-full max-w-80">
                                  <div className="text-base font-semibold mb-2">No Properties Available</div>
                                  <div className="text-sm text-gray-600 mb-3">Currently no properties are loaded. In a real scenario, you would see available listings here to explore and book.</div>
                                  <div className="flex flex-col gap-2">
                                    <BlackButton text="Back" onClick={() => prevStep()} />
                                    <PurpleButton text="Next" onClick={() => nextStep()} />
                                    <button 
                                      onClick={handleSkipOnboarding}
                                      className="px-3 py-2 text-gray-500 hover:text-gray-700 text-sm"
                                    >
                                      Skip Guide
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <NoResultsPrompt 
                                  onJoinWaitlist={handleJoinWaitlist}
                                  onResetFilters={handleResetFilters}
                                  isSearchResult={isSearchResult}
                                />
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                ) : (
                  /* Mobile Map View - Copy from Rent.js */
                  <div className="w-full h-[calc(100vh-300px)] relative pb-20">
                    <GoogleMap
                      center={pinLocation}
                      zoom={zoom}
                      mapContainerClassName="w-full h-full rounded-lg mx-2 shadow-lg"
                      options={{
                        mapTypeControl: false,
                        streetViewControl: false,
                        fullscreenControl: false,
                        zoomControl: false,
                        styles: mapStyles,
                      }}
                    >
                      {/* Map Controls */}
                      <div className="absolute top-3 sm:top-4 right-3 sm:right-4 flex flex-col gap-2">
                        <div className="p-2 rounded-full hover:bg-[#000000] shadow-md bg-gradient-to-b from-[#202020c0] from-0% to-70% to-[#202020]">
                          <MapShareIcon />
                        </div>
                        <div
                          className="p-2 rounded-full shadow-md bg-white hover:bg-[#f6f6f6] cursor-pointer"
                          onClick={() => setZoom(zoom + 1)}
                        >
                          <MapPlusIcon />
                        </div>
                        <div
                          className="p-2 rounded-full shadow-md bg-white hover:bg-[#f6f6f6] cursor-pointer"
                          onClick={() => setZoom(zoom - 1)}
                        >
                          <MapMinusIcon />
                        </div>
                      </div>

                      {/* Property Markers */}
                      {visibleProperties?.map((nft, index) => {
                        // Only render properties that have location data
                        if (!nft?.metaData?.location?.lat || !nft?.metaData?.location?.lng) {
                          return null;
                        }
                        
                        return (
                            <OverlayView
                              position={nft.metaData.location}
                              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                              key={index}
                            >
                              <div>
                                <div
                                  onClick={() => {
                                    navigate(location.pathname + "/" + nft?.token_id);
                                  }}
                                  onMouseEnter={() => setActiveToken(nft?.token_id)}
                                  onMouseLeave={() => setActiveToken(null)}
                                  className={
                                    nft?.token_id === activeToken
                                      ? "w-max px-[8px] sm:px-[12px] py-[4px] sm:py-[6px] rounded-[8px] sm:rounded-[12px] bg-gradient-to-b from-[#202020c0] from-0% to-70% to-[#202020] text-white text-center cursor-pointer shadow-md"
                                      : "w-max px-[8px] sm:px-[12px] py-[4px] sm:py-[6px] rounded-[8px] sm:rounded-[12px] bg-gradient-to-b from-[#5b1deec0] hover:from-[#202020c0] from-0% to-70% to-[#5b1dee] hover:to-[#202020] text-white text-center cursor-pointer shadow-md"
                                  }
                                >
                                  <div className="flex items-center gap-[2px] sm:gap-[4px]">
                                    <NUSDIcon className="w-[16px] sm:w-[20px]" />
                                    <div className="text-sm sm:text-[16px]">
                                      ${nft?.short?.price_per_day}
                                    </div>
                                  </div>
                                </div>
                                {nft?.token_id === activeToken && (
                                  <div className="scale-x-[0.4] scale-y-[0.3] sm:scale-x-[0.6] sm:scale-y-[0.5] left-[-30px] sm:left-[-50px] origin-top z-[200] absolute">
                                    <RentalItem
                                      token_id={nft?.token_id}
                                      confetti={false}
                                      tokenData={nft}
                                    />
                                  </div>
                                )}
                              </div>
                            </OverlayView>
                          );
                      })}

                      <Marker
                        position={pinLocation}
                        draggable
                        onDragEnd={(e) => {
                          setPinLocation({
                            lat: e.latLng.lat(),
                            lng: e.latLng.lng(),
                          });
                        }}
                        icon={{
                          url: mapPinIcon,
                          scaledSize: new window.google.maps.Size(60, 60),
                          origin: new window.google.maps.Point(0, 0),
                          anchor: new window.google.maps.Point(30, 51),
                        }}
                      />
                    </GoogleMap>
                  </div>
                )}
                
                {/* Mobile Onboarding Modal for step 6 - Fixed center position */}
                {isOnboarding && currentStep === 6 && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[99999] p-4">
                    <div className="bg-white rounded-lg shadow-lg p-4 border-4 border-purple-500 onboarding-highlight w-full max-w-sm" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                      <div className="text-lg font-semibold mb-2">Explore Property Details</div>
                      <div className="text-sm text-gray-600 mb-4">Click "View Details" on any listing to see full information, photos, and book your stay!</div>
                      
                      <div className="flex items-center gap-3 mb-4 p-3 bg-purple-50 rounded-lg">
                        <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center text-white">
                          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" clipRule="evenodd" />
                          </svg>
                        </div>
                        <div className="text-sm text-gray-700">
                          <div className="font-medium">Property Listings</div>
                          <div className="text-xs text-gray-500">See details and book instantly!</div>
                        </div>
                      </div>
                      
                      <div className="flex flex-col gap-2">
                        <BlackButton text="Back" onClick={() => prevStep()} />
                        <PurpleButton text="Next" onClick={() => nextStep()} />
                        <button 
                          onClick={handleSkipOnboarding}
                          className="px-3 py-2 text-gray-500 hover:text-gray-700 text-sm text-center"
                        >
                          Skip Guide
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Desktop Version - Copy from Rent.js */}
              <div className="hidden lg:flex w-full h-full max-h-[calc(100vh-200px)] relative">
                {/* Desktop Onboarding Modal for step 6 - Fixed left position */}
                {isOnboarding && currentStep === 6 && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-start z-[99999] p-8">
                    <div className="bg-white rounded-lg shadow-lg p-6 border-4 border-purple-500 onboarding-highlight w-full max-w-md ml-8" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                      <div className="text-xl font-semibold mb-3">Explore Property Details</div>
                      <div className="text-gray-600 mb-6">Click "View Details" on any listing to see full information, photos, and book your stay!</div>
                      
                      <div className="flex items-center gap-4 mb-6 p-4 bg-purple-50 rounded-lg">
                        <div className="w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center text-white">
                          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" clipRule="evenodd" />
                          </svg>
                        </div>
                        <div className="text-sm text-gray-700">
                          <div className="font-semibold text-base">Property Listings</div>
                          <div className="text-sm text-gray-500">See details and book instantly!</div>
                        </div>
                      </div>

                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                        <div className="flex items-center gap-3">
                          <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                          </svg>
                          <div className="text-sm text-blue-800">
                            <div className="font-medium">Tip</div>
                            <div className="text-xs">Look for listings on the right side of the screen!</div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="flex gap-3">
                        <BlackButton text="Back" onClick={() => prevStep()} />
                        <PurpleButton text="Next" onClick={() => nextStep()} />
                        <button 
                          onClick={handleSkipOnboarding}
                          className="px-4 py-2 text-gray-500 hover:text-gray-700 rounded-lg transition-colors"
                        >
                          Skip Guide
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <div
                  className={
                    fullScreen
                      ? "w-0 hidden"
                      : (visibleProperties.length === 0)
                      ? "w-1/2 flex flex-col h-full" 
                      : hideMap
                      ? "w-full flex flex-col h-full"
                      : "w-max flex flex-col h-full"
                  }
                >
                  <div className="grid grid-cols-3 items-center w-full relative">
                    <div className="flex items-center">
                      <ShortRentalIcon />
                      <div className="text-[24px] font-semibold min-w-[300px]">
                        Short-Term Rental
                      </div>
                    </div>
                    
                    <Popover
                      isOpen={showMapMenu}
                      positions={"bottom"}
                      onClickOutside={() => setShowMapMenu(false)}
                      content={
                        <div
                          onClick={() => setShowMapMenu(false)}
                          className="mt-[10px] bg-white rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                        >
                          {!fullScreen && !hideMap && (
                            <div
                              onClick={() => setHideMap(true)}
                              className="cursor-pointer hover:bg-[#f5f5f5] rounded-t-[10px] p-[8px] gap-[8px] flex items-center w-full"
                            >
                              <GridLayoutIconRent />
                              <div className="text-[#666666]">Hide Map</div>
                            </div>
                          )}
                          {!fullScreen && hideMap && (
                            <div
                              onClick={() => setHideMap(false)}
                              className="cursor-pointer hover:bg-[#f5f5f5] rounded-t-[10px] p-[8px] gap-[8px] flex items-center w-full"
                            >
                              <GridLayoutIconRent />
                              <div className="text-[#666666]">Show Map</div>
                            </div>
                          )}

                          <div
                            onClick={() => {
                              setHideMap(false);
                              setFullScreen(true);
                            }}
                            className="cursor-pointer hover:bg-[#f5f5f5] rounded-b-[10px] p-[8px] gap-[8px] flex items-center w-full"
                          >
                            <PinLocationIconRent />
                            <div className="text-[#666666]">View Full Map</div>
                          </div>
                        </div>
                      }
                    >
                      <div
                        onClick={() => setShowMapMenu(true)
                        }
                        className="justify-self-center hover:bg-[#f6f6f6] select-none w-max py-[4px] cursor-pointer bg-white rounded-[10px] px-[14px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                      >
                        <MapLineIconRent />
                        <div className="font-semibold">View Map</div>
                      </div>
                    </Popover>
                  </div>

                  <div className={
                    hideMap
                      ? "w-full flex flex-wrap py-[10px] gap-4 overflow-auto h-[calc(100vh-270px)] px-[20px]"
                      : (visibleProperties.length === 0)
                      ? "w-full flex items-center justify-center py-[10px] gap-4 overflow-auto h-[calc(100vh-270px)] px-[20px]"
                      : "w-max grid 2xl:grid-cols-3 xl:grid-cols-2 lg:grid-cols-1 sm:grid-cols-1 py-[10px] gap-4 overflow-auto h-[calc(100vh-270px)] px-[20px]"
                  }>
                    {(loading || isPreloading) ? (
                      <div className="col-span-full w-full flex items-center justify-center h-full">
                        {isOnboarding && currentStep === 6 && (
                          <div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 border-4 border-purple-500 z-[1051] onboarding-highlight w-[95vw] max-w-80" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                            <div className="text-base sm:text-lg font-semibold mb-2">
                              {isPreloading ? 'Pre-loading Properties' : 'Loading Properties'}
                            </div>
                            <div className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                              {isPreloading 
                                ? 'Getting properties ready for your exploration...' 
                                : 'Please wait while we load available listings for you to explore.'
                              }
                            </div>
                            <div className="flex justify-center">
                              <div className="animate-spin rounded-full h-6 w-6 sm:h-8 sm:w-8 border-b-2 border-purple-500" />
                            </div>
                          </div>
                        )}
                        {!(isOnboarding && currentStep === 6) && (
                          <PropertySkeletonGrid count={9} />
                        )}
                      </div>
                    ) : (
                      <>
                        {visibleProperties.length > 0 ? (
                          visibleProperties.map((nft, index) => (
                            <div
                              key={index}
                              className={`w-max h-max transition-all duration-300 ease-in-out relative`}
                            >
                              <RentalItem
                                token_id={nft?.token_id}
                                tokenData={nft}
                                isFirstListing={index === 0}
                                isOnboarding={isOnboarding}
                                currentStep={currentStep}
                              />
                            </div>
                          ))
                        ) : (
                          <div className="col-span-full w-full flex items-center justify-center h-full">
                            {isOnboarding && currentStep === 6 ? (
                              <div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 border-4 border-purple-500 z-[1051] onboarding-highlight w-[95vw] max-w-80" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
                                <div className="text-base sm:text-lg font-semibold mb-2">No Properties Available</div>
                                <div className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">Currently no properties are loaded. In a real scenario, you would see available listings here to explore and book.</div>
                                <div className="flex flex-col sm:flex-row gap-2">
                                  <BlackButton text="Back" onClick={() => prevStep()} />
                                  <PurpleButton text="Next" onClick={() => nextStep()} />
                                  <button 
                                    onClick={handleSkipOnboarding}
                                    className="px-3 sm:px-4 py-2 text-gray-500 hover:text-gray-700 text-sm"
                                  >
                                    Skip Guide
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <NoResultsPrompt 
                                onJoinWaitlist={handleJoinWaitlist}
                                onResetFilters={handleResetFilters}
                                isSearchResult={isSearchResult}
                              />
                            )}
                          </div>
                        )}
                        <div ref={observerTarget} className="h-10 w-full" />
                        {hasMoreProperties && (
                          <div className="w-full flex justify-center p-4">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500" />
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
                
                {/* Desktop Map */}
                <GoogleMap
                  center={pinLocation}
                  zoom={zoom}
                  mapContainerClassName={
                    hideMap
                      ? "w-0"
                      : (visibleProperties.length === 0)
                      ? "relative w-1/2 mx-[10px] h-full rounded-[8px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                      : "relative w-full mx-[10px] h-full rounded-[8px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                  }
                  options={{
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    zoomControl: false,
                    styles: mapStyles,
                  }}
                >
                  <div className="absolute top-[20px] left-[20px]">
                    <div
                      onClick={() => setFullScreen(!fullScreen)}
                      className="p-[4px] rounded-full shadow-md bg-white cursor-pointer hover:bg-[#f6f6f6]"
                    >
                      {fullScreen ? <ArrowToRightIcon /> : <ArrowToLeft />}
                    </div>
                  </div>
                  <div className="absolute top-[20px] right-[20px] flex items-center gap-[10px]">
                    <div className="p-[4px] rounded-full hover:bg-[#000000] shadow-md bg-gradient-to-b from-[#202020c0] from-0% to-70% to-[#202020]">
                      <MapShareIcon />
                    </div>
                    <div
                      className="p-[4px] rounded-full shadow-md bg-white hover:bg-[#f6f6f6] cursor-pointer"
                      onClick={() => setZoom(zoom + 1)}
                    >
                      <MapPlusIcon />
                    </div>
                    <div
                      className="p-[4px] rounded-full shadow-md bg-white hover:bg-[#f6f6f6] cursor-pointer"
                      onClick={() => setZoom(zoom - 1)}
                    >
                      <MapMinusIcon />
                    </div>
                  </div>
                  {visibleProperties?.map((nft, index) => {
                    // Only render properties that have location data
                    if (!nft?.metaData?.location?.lat || !nft?.metaData?.location?.lng) {
                      return null;
                    }
                    
                    return (
                        <OverlayView
                          key={index}
                          position={{
                            lat: parseFloat(nft.metaData.location.lat),
                            lng: parseFloat(nft.metaData.location.lng),
                          }}
                          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                          getPixelPositionOffset={(width, height) => ({
                            x: -(width / 2),
                            y: -height,
                          })}
                        >
                          <div
                            className={`${
                              activeToken === nft?.token_id ? "translate-y-[-4px]" : ""
                            } transition-all duration-300 ease-in-out`}
                          >
                            <div
                              onClick={() => {
                                navigate(location.pathname + "/" + nft?.token_id);
                              }}
                              onMouseEnter={() => setActiveToken(nft?.token_id)}
                              onMouseLeave={() => setActiveToken(null)}
                              className={
                                nft?.token_id === activeToken
                                  ? "w-max px-[12px] py-[6px] rounded-[12px] bg-gradient-to-b from-[#202020c0] from-0% to-70% to-[#202020] text-white text-center cursor-pointer shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                                  : "w-max px-[12px] py-[6px] rounded-[12px] bg-gradient-to-b from-[#5b1deec0] hover:from-[#202020c0] from-0% to-70% to-[#5b1dee] hover:to-[#202020] text-white text-center cursor-pointer shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                              }
                            >
                              <div className="flex items-center gap-[4px]">
                                <NUSDIcon className="w-[20px]" />
                                <div className="text-[16px]">
                                  ${nft?.short?.price_per_day}
                                </div>
                              </div>
                            </div>
                            {nft?.token_id === activeToken && (
                              <div className="scale-x-[0.6] scale-y-[0.5] left-[-50px] origin-top z-[200] absolute">
                                <RentalItem
                                  token_id={nft?.token_id}
                                  confetti={false}
                                  tokenData={nft}
                                />
                              </div>
                            )}
                          </div>
                        </OverlayView>
                      );
                  })}

                  <Marker
                    position={pinLocation}
                    draggable
                    onDragEnd={(e) => {
                      setPinLocation({
                        lat: e.latLng.lat(),
                        lng: e.latLng.lng(),
                      });
                    }}
                    icon={{
                      url: mapPinIcon,
                      scaledSize: new window.google.maps.Size(80, 80),
                      origin: new window.google.maps.Point(0, 0),
                      anchor: new window.google.maps.Point(40, 68),
                    }}
                  />
                </GoogleMap>
              </div>
            </>
          )}

          {/* Long Term Rental Section - existing code... */}
        </div>
      </div>
      
      <Chatbot />
      
      {/* AI instruction modal - mobile responsive */}
    {isOnboarding && currentStep === 1 && (
  <div className="fixed bottom-28 right-2 sm:bottom-32 sm:right-4 lg:bottom-32 lg:right-8 w-[calc(100vw-1rem)] max-w-80 bg-white rounded-lg shadow-lg p-3 sm:p-4 border-4 border-purple-500 z-[99999] onboarding-highlight pointer-events-auto" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
    <div className="text-base sm:text-lg font-semibold mb-2">Plan Your Trip with Coded AI</div>
    <div className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">Your AI assistant is ready to help you find the perfect rental and answer any questions!</div>
    
    <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4 p-2 sm:p-3 bg-purple-50 rounded-lg">
      <div className="w-6 h-6 sm:w-8 sm:h-8 bg-purple-600 rounded-full flex items-center justify-center text-white">
        <Chatboticon/>
      </div>
      <div className="text-xs sm:text-sm text-gray-700">
        <div className="font-medium">Coded AI</div>
        <div className="text-xs text-gray-500">Click the chatbot icon below to start!</div>
      </div>
    </div>

          {/* Arrow pointing down to the chatbot icon on mobile */}
            <div className="lg:hidden absolute -bottom-3 right-4 sm:right-8 w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-purple-500"></div>
    
    <div className="onboarding-modal-buttons">
      <BlackButton text="Back" onClick={() => prevStep()} />
      <PurpleButton text="Next" onClick={() => nextStep()} />
      <button 
        onClick={handleSkipOnboarding}
        className="px-3 sm:px-4 py-2 text-gray-500 hover:text-gray-700 text-sm"
      >
        Skip Guide
      </button>
    </div>
  </div>
)}

      {/* Mobile Onboarding Modals - Positioned below toggle */}
      {isOnboarding && currentStep === 8 && (
        <div className="w-full max-w-full bg-white rounded-lg shadow-lg p-3 border-4 border-purple-500 z-[1051] onboarding-highlight overflow-hidden" style={{ backgroundColor: '#ffffff', background: '#ffffff', opacity: 1 }}>
          <div className="text-base font-semibold mb-2">Connect Your Wallet</div>
          <div className="text-sm text-gray-600 mb-3">Tap the menu (☰) at the top right to access "Connect Wallet" and secure your account!</div>
          
          <div className="flex items-center gap-2 mb-3 p-2 bg-purple-50 rounded-lg">
            <div className="w-6 h-6 bg-purple-600 rounded-full flex items-center justify-center text-white flex-shrink-0">
              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="text-xs text-gray-700 min-w-0">
              <div className="font-medium">Wallet Connection</div>
              <div className="text-xs text-gray-500">Secure crypto payments!</div>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-2 mb-3">
            <div className="flex items-start gap-2">
              <svg className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              <div className="text-xs text-blue-800 min-w-0">
                <div className="font-medium">Mobile Menu Access</div>
                <div className="text-xs break-words">Look for the ☰ icon in the top right corner!</div>
              </div>
            </div>
          </div>
          
          <div className="onboarding-modal-buttons">
            <BlackButton text="Back" onClick={() => prevStep()} />
            <PurpleButton text="Next" onClick={() => nextStep()} />
            <button 
              onClick={handleSkipOnboarding}
              className="px-3 py-2 text-gray-500 hover:text-gray-700 text-sm"
            >
              Skip Guide
            </button>
          </div>
        </div>
      )}

      <WaitlistModal />
      <OnboardingModal />
      <Toaster />
    </div>
  );
};
